export const timezone = 'Europe/Prague';
